import {
  initialState,
  Actions,
  State,
  EDIT_NOTIFICATION,
  EDIT_NOTIFICATION_SUCCESS,
  EDIT_NOTIFICATION_ERROR,
  RESET_EDIT_NOTIFICATION,
} from '../../types/notification/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_NOTIFICATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_NOTIFICATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_NOTIFICATION:
      return initialState
    default:
      return state
  }
}

export default reducers
